export enum InvoicePeriodicityEnum {

  monthly = 1,
  bimonthly = 2

}
